var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0.821
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 3.369,
    x2: 94.75,
    y1: 3.202,
    y2: 94.914,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 3.37,
    x2: 94.751,
    y1: 3.2,
    y2: 94.913,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m23.41 46.934-.114-.114c-.78-1.334-1.057-2.838-1-4.342H3.333c-.667 0-1 .78-.61 1.276l4.798 5.798a.528.528 0 0 1 0 .675L2.666 56.3c-.39.504-.057 1.285.618 1.285l19.898-.057c-2.618-2.96-2.675-7.473.114-10.482zm69.069 3.513c-.163-.171-.163-.505 0-.667l4.854-6.083c.39-.496.057-1.276-.61-1.276l-19.905.057c2.675 3.008 2.675 7.578-.057 10.53l-.114.114.114.114c.78 1.333 1.057 2.837 1 4.35h18.963c.61-.057 1-.78.61-1.285z",
    opacity: 1,
    "data-original": "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M73.305 49.78c1.285-1.399 1.057-3.627-.504-4.741l-1.057-.724c-1.114-.78-1.619-2.179-1.228-3.456l.39-1.17c.561-1.79-.61-3.741-2.456-4.018l-1.22-.22a3.214 3.214 0 0 1-2.626-2.626l-.22-1.22c-.333-1.902-2.17-3.073-4.016-2.569l-1.22.334c-1.285.39-2.684-.106-3.464-1.228l-.724-1.057c-1.114-1.562-3.285-1.838-4.684-.553l-.943.83c-1.008.894-2.512 1.064-3.627.39l-1.057-.61c-1.618-.944-3.732-.163-4.464 1.56l-.496 1.172c-.504 1.285-1.789 2.008-3.18 1.951l-1.227-.114a3.165 3.165 0 0 0-3.342 3.35l.105 1.22c.114 1.342-.723 2.627-2 3.123l-1.122.675c-1.724.723-2.505 2.838-1.561 4.456l.618 1.057c.667 1.228.504 2.626-.447 3.684l-.838.95c-1.277 1.391-1.057 3.62.504 4.733l1.057.724c1.114.78 1.618 2.18 1.228 3.464l-.39 1.163c-.561 1.789.61 3.74 2.456 4.017l1.227.228a3.196 3.196 0 0 1 2.619 2.618l.22 1.228a3.203 3.203 0 0 0 4.016 2.561l1.228-.333c1.277-.39 2.675.114 3.456 1.228l.724 1.057c1.114 1.561 3.285 1.838 4.684.56l.943-.837c1.008-.894 2.512-1.065 3.626-.39l1.058.61c1.618.951 3.74.17 4.464-1.561l.496-1.171c.504-1.285 1.789-2.009 3.18-1.952l1.227.114a3.154 3.154 0 0 0 3.342-3.342l-.106-1.455c-.114-1.334.724-2.619 2.009-3.123l1.114-.447c1.724-.724 2.504-2.838 1.561-4.456l-.618-1.058c-.667-1.227-.496-2.626.447-3.683zm-15.442 8.082a11.106 11.106 0 0 1-15.726 0 11.12 11.12 0 0 1 15.726-15.726 11.106 11.106 0 0 1 0 15.726z",
    opacity: 1,
    "data-original": "url(#c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.fca0c4f7ef53f59ce229a60eb174b62a.svg";
export { ForwardRef as ReactComponent };